import { ConfigProvider, Input, Table, TableProps } from 'antd';
import enUS from 'antd/lib/locale/en_US';

interface GenericListProps<T> extends TableProps<T> {
  onSearch?: (value: string) => void;
}

export function GenericList<T extends object>({
  className,
  onSearch,
  ...props
}: GenericListProps<T>) {
  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        components: {
          Table: {
            headerBg: '#1a1a1a',
            headerColor: '#ffffff',
            headerSortActiveBg: '#2a2a2a',
            bodySortBg: '#181818',
            headerSortHoverBg: '#2a2a2a'
          },
          Pagination: {
            itemActiveBg: '#E3AF25',
            itemBg: '#27272a',
            itemInputBg: '#222',
            itemLinkBg: '#222'
          }
        }
      }}
    >
      <div
        className={`w-full ${className} overflow-hidden border border-b-0 border-zinc-700`}
      >
        <div className='bg-zinc-800 px-4 py-4'>
          <div className='md:w-md w-full'>
            <Input.Search
              placeholder='Search'
              size='large'
              onSearch={onSearch}
              className='!font-["Barlow"] [&_.ant-input-search-button]:!bg-[#E3AF25] [&_.ant-input-search-button]:!border-[#E3AF25] [&_.ant-input-search-button_.anticon]:!text-black [&_.ant-input-search-button:hover]:!bg-[#d4a020] [&_.ant-input-search-button:hover]:!border-[#d4a020]'
              style={{ width: '100%' }}
            />
          </div>
        </div>
        <div className='border-t border-zinc-700 overflow-x-auto border-b-4 border-b-[#E3AF25]'>
          <Table<T>
            {...props}
            rowKey='id'
            locale={{
              emptyText: 'No data',
              triggerDesc: 'Click to sort descending',
              triggerAsc: 'Click to sort ascending',
              cancelSort: 'Click to cancel sorting'
            }}
            pagination={{
              ...props.pagination,
              showTotal: (total, range) =>
                <span className="!font-['Barlow'] text-white">{`${range[0]}-${range[1]} of ${total} items`}</span>
            }}
            className='[&_tbody_tr]:cursor-pointer [&_.ant-table]:!rounded-none [&_.ant-table-thead>tr>th]:!bg-zinc-900 [&_.ant-table-thead>tr>th]:!text-white [&_.ant-table-thead>tr>th]:!font-["Android_101"] [&_.ant-table-thead>tr>th]:!font-normal [&_.ant-table-thead>tr>th:first-child]:!rounded-none [&_.ant-table-thead>tr>th:last-child]:!rounded-none [&_th]:!border-zinc-700 [&_td]:!border-zinc-700 [&_.ant-table-tbody>tr>td]:!bg-zinc-800 [&_.ant-table-tbody>tr>td]:!text-white [&_.ant-table-tbody>tr>td]:!font-["Barlow"] [&_.ant-table-tbody>tr:hover>td]:!bg-zinc-700 [&_.ant-pagination]:!text-white [&_.ant-pagination-total-text]:!text-white [&_.ant-pagination-item-link]:!bg-zinc-800 [&_.ant-pagination-item-link]:!border-zinc-700 [&_.ant-pagination-item-link]:!text-white [&_.ant-pagination-item-link]:!rounded-none [&_.ant-pagination-item]:!bg-zinc-800 [&_.ant-pagination-item]:!border-zinc-700 [&_.ant-pagination-item]:!text-white [&_.ant-pagination-item]:!rounded-none [&_.ant-pagination-item a]:!text-white [&_.ant-pagination-item.ant-pagination-item-active]:!bg-[#E3AF25] [&_.ant-pagination-item.ant-pagination-item-active]:!text-black [&_.ant-pagination-item.ant-pagination-item-active]:!rounded-none [&_.ant-pagination-item.ant-pagination-item-active a]:!text-black [&_.ant-pagination-prev]:!rounded-none [&_.ant-pagination-next]:!rounded-none [&_.ant-pagination-options-size-changer_.ant-select-selector]:!rounded-none [&_.ant-pagination-options]:!mr-4 [&_.ant-pagination-options-size-changer_.ant-select-selection-item]:!text-white [&_.ant-pagination-options-size-changer_.ant-select-arrow]:!text-white [&_.ant-pagination-options-size-changer_.ant-select-selection-search_.anticon]:!text-white [&_.ant-table-column-title]:!uppercase [&_.ant-table-column-title]:!text-white [&_.ant-table-column-title]:!font-["Android_101"] [&_.ant-table-column-title]:!font-normal [&_.ant-empty-description]:!text-white [&_.ant-empty-description]:!font-["Barlow"] [&_.ant-table-column-sorter-up]:!text-white [&_.ant-table-column-sorter-down]:!text-white [&_.ant-table-column-sorter-up.active]:!text-[#E3AF25] [&_.ant-table-column-sorter-down.active]:!text-[#E3AF25]'
          />
        </div>
      </div>
    </ConfigProvider>
  );
}
